module.exports = "<iframe id=vimeo-player{{videoId}} ng-src=\"{{ src }}\" width=100% height=100% frameborder=0 webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-players/nn-player-vimeo/nn-player-vimeo.directive.html
// module id = 1044
// module chunks = 0